var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SwiperSlider',{ref:"swiper",class:['categoryBrands', { 'categoryBrands--popup': _vm.isPopup }],attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.brands),function(item,index){return _c('div',{key:index,staticClass:"categoryBrands__slide swiper-slide"},[_c('nuxt-link',{staticClass:"categoryBrands__slideLink",attrs:{"to":_vm.localePath({
          name: 'brand-slug',
          params: {
            slug: item.slug,
          },
        })}},[_c('new-image-box',{attrs:{"alt":item.name,"background-color":"#fff","src":item.logoUrl100x80,"width":100,"height":60,"image-params":"w_100,h_60"}})],1)],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }